var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUserAlt = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.2 8.147a3.28 3.28 0 001.133-2.48 3.333 3.333 0 00-6.666 0A3.28 3.28 0 003.8 8.147 5.333 5.333 0 00.667 13 .667.667 0 102 13a4 4 0 018 0 .667.667 0 101.333 0A5.334 5.334 0 008.2 8.147zM6 7.667a2 2 0 110-4 2 2 0 010 4zm6.493.213A3.332 3.332 0 0010 2.333a.667.667 0 100 1.334 2 2 0 012 2 2 2 0 01-1 1.726.667.667 0 00-.033 1.134l.26.173.086.047A4.667 4.667 0 0113.98 13a.667.667 0 101.333 0 6 6 0 00-2.82-5.12z",
  fill: "#44494D"
})));
export default __webpack_public_path__ + "static/userAlt.[git-hash].svg";
export { SvgUserAlt as ReactComponent };